import {useStyletron} from "baseui";
import {Button, KIND, SIZE} from "baseui/button";
import React from "react";

export const LinkButton = ({
    children,
    hover = false,
    colour,
    hoverColour,
    underline = true,
    onClick,
    type = "button",
    $style,
}) => {
    const [css, theme] = useStyletron();

    // underline + hover: no underline until hover (matches static marketing links)
    // underline without hover: always underlined
    let textDecoration;
    let hoverStyles;
    if (hover) {
        if (underline) {
            textDecoration = "none";
            hoverStyles = {
                textDecoration: "underline",
                textUnderlineOffset: "4px",
                color: hoverColour ?? colour ?? theme.colors.contentSecondary,
            };
        } else {
            textDecoration = undefined;
            hoverStyles = {
                color: hoverColour ?? theme.colors.contentSecondary,
            };
        }
    } else {
        textDecoration = underline ? "underline" : undefined;
        hoverStyles = undefined;
    }

    return (
        <button
            type={type}
            className={css({
                ...$style,
                background: "none",
                color: colour ?? theme.colors.contentSecondary,
                border: "none",
                cursor: "pointer",
                alignItems: "center",
                ":hover": hover ? hoverStyles : undefined,
                textDecoration,
            })}
            onClick={onClick}
        >
            {children}
        </button>
    );
};

export const ButtonPrimary = ({children, size, $style, ...props}) => {
    const [css, theme] = useStyletron();
    const style = {

        ...$style
    };
    return (
        <Button {...props}
                size={size ?? SIZE.default}
                kind={KIND.primary}
                style={style} //cant figure out why doesnt apply if you use styletron css()
        >
            {children}
        </Button>
    );
};

export const ButtonSecondary = ({children, size, $style, ...props}) => {
    const [css, theme] = useStyletron();
    const style = {
        borderRadius: theme.borders.radius300,
        ...$style
    };
    return (
        <Button {...props}
                size={size ?? SIZE.compact}
                kind={KIND.secondary}
                style={style} //cant figure out why doesnt apply if you use styletron css()
        >
            {children}
        </Button>
    );
};

export const ButtonTertiary = ({children, size, $style, ...props}) => {
    const [css, theme] = useStyletron();
    const style = {
        borderRadius: theme.borders.radius300,
        ...$style
    };
    return (
        <Button {...props}
                size={size ?? SIZE.mini}
                kind={KIND.tertiary}
                style={style} //cant figure out why doesnt apply if you use styletron css()
        >
            {children}
        </Button>
    );
};

